module.exports = __webpack_public_path__ + "img/bb_g3_t_mouth-02.4ff0ccac.svg";